// ErrorFallback.tsx
import { TErrorFallbackProps } from "../../core/types/error-fallback";
import ErrorDetails from "./ErrorDetails";

export default function ErrorFallback({
  isError,
  children,
  error,
  errormsg,
  className,
}: TErrorFallbackProps) {
  return isError ? (
    <ErrorDetails
      error={error}
      errormsg={errormsg}
      className={className ?? ""}
    />
  ) : (
    <>{children}</>
  );
}
